import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { useMatch } from '@xing-com/crate-core-router';
import { useLocalStorage } from '@xing-com/crate-hooks-use-web-storage';
import { useBreakpoints } from '@xing-com/crate-jobs-hooks';
import { ROUTES } from '@xing-com/crate-jobs-paths';
import { useExperiment } from '@xing-com/hub';
import { TipBoxPreset } from '@xing-com/tip-box';

const MOBILE_OFFSET = 44;
const DESKTOP_OFFSET = 12;
const LOCAL_STORAGE_KEY = 'ai-serps-tip-box';

export const AiSERPSTipBox: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { formatMessage } = useIntl();
  const { isMediaSmallOrTiny } = useBreakpoints();
  const isAiSearchForced = useExperiment('ABACUS-468') === 'B';
  const isAiSERPS = !!useMatch(ROUTES.searchAi);
  const [isFirstTime, setIsFirstTime] = useLocalStorage(
    LOCAL_STORAGE_KEY,
    true
  );

  const shouldNotShow = !isFirstTime || !isAiSearchForced || !isAiSERPS;
  if (shouldNotShow) {
    return children;
  }

  const onDisableAutofocus = (e: Event): void => {
    e.preventDefault();
  };

  const onInteractOutside = (e: Event): void => {
    // We don't want to close the tip box when clicking outside of it
    e.preventDefault();
  };

  const onOpenChange = (state: boolean): void => {
    if (!state) {
      setIsFirstTime(false);
    }
  };

  return (
    <Container>
      <TipBox
        open
        align="center"
        headlineText={formatMessage({
          id: 'JOBS_SEARCH_RESULTS_GUIDANCE_HEADLINE',
        })}
        bodyText={formatMessage({ id: 'JOBS_SEARCH_RESULTS_GUIDANCE_TEXT' })}
        markerText={formatMessage({
          id: 'JOBS_SEARCH_RESULTS_GUIDANCE_MARKER',
        })}
        side={isMediaSmallOrTiny ? 'bottom' : 'right'}
        variant="highlighted"
        trigger={children}
        onOpenAutoFocus={onDisableAutofocus}
        onOpenChange={onOpenChange}
        onInteractOutside={onInteractOutside}
        sideOffset={isMediaSmallOrTiny ? MOBILE_OFFSET : DESKTOP_OFFSET}
        showArrow
        showClosingIndicator={false}
      />
    </Container>
  );
};

const TipBox = styled(TipBoxPreset)`
  max-width: 220px;
`;

const Container = styled.div`
  grid-area: key;

  & > button {
    width: 100%;
  }
`;
